// Cleanup function for expired DataTables states
function cleanupExpiredDataTablesStates() {
  const now = new Date().getTime();
  const EXPIRY_HOURS = 24; // States older than 24 hours will be removed
  
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.startsWith('DataTables_')) {
      const state = JSON.parse(localStorage.getItem(key));
      if (state && state.time && (now - state.time > EXPIRY_HOURS * 60 * 60 * 1000)) {
        localStorage.removeItem(key);
      }
    }
  }
}

// Cleanup function for expired Tus upload states
function cleanupExpiredTusStates() {
  const now = new Date().getTime();
  const EXPIRY_HOURS = 24; // States older than 24 hours will be removed
  
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.startsWith('tus::')) {
      const state = JSON.parse(localStorage.getItem(key));
      if (state && state.creationTime) {
        const creationTime = new Date(state.creationTime).getTime();
        if (now - creationTime > EXPIRY_HOURS * 60 * 60 * 1000) {
          localStorage.removeItem(key);
        }
      }
    }
  }
}

function cleanupExpiredStates() {
  cleanupExpiredDataTablesStates();
  cleanupExpiredTusStates();
}

// Run cleanup every 2 hours
setInterval(cleanupExpiredStates, 2 * 60 * 60 * 1000);